import { render, staticRenderFns } from "./TourNovedades.vue?vue&type=template&id=979161b0&scoped=true"
import script from "./TourNovedades.vue?vue&type=script&lang=js"
export * from "./TourNovedades.vue?vue&type=script&lang=js"
import style0 from "./TourNovedades.vue?vue&type=style&index=0&id=979161b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979161b0",
  null
  
)

export default component.exports